import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const BadSmileyIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='a' viewBox='0 0 170 170'
      fill={theme.palette.text.primary} height={props.width} width={props.width} xmlns='http://www.w3.org/2000/svg'
      data-name='svg'
    >
      <g>
        <path
          d='m69.862 51.121c-1.953-1.953-5.118-1.953-7.071 0l-6.771 6.771-6.771-6.771c-1.953-1.952-5.118-1.953-7.071 0-1.953 1.952-1.953 5.118 0 7.07l6.771 6.771-6.771 6.771c-1.953 1.952-1.953 5.118 0 7.07.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465l6.771-6.771 6.771 6.771c.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465c1.953-1.952 1.953-5.118 0-7.07l-6.771-6.771 6.771-6.771c1.953-1.952 1.953-5.118 0-7.07z'
        />
        <path
          d='m128.009 51.121c-1.953-1.953-5.118-1.953-7.071 0l-6.771 6.771-6.771-6.771c-1.953-1.953-5.118-1.953-7.071 0-1.953 1.952-1.953 5.118 0 7.07l6.771 6.771-6.771 6.771c-1.953 1.952-1.953 5.118 0 7.07.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465l6.771-6.771 6.771 6.771c.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465c1.953-1.952 1.953-5.118 0-7.07l-6.771-6.771 6.771-6.771c1.953-1.952 1.953-5.118 0-7.07z'
        />
        <path
          d='m85 5c-44.112 0-80 35.888-80 80s35.888 80 80 80 80-35.888 80-80-35.888-80-80-80zm0 150c-38.598 0-70-31.402-70-70s31.402-70 70-70 70 31.402 70 70-31.402 70-70 70z'
        />
      </g>
      <path
        d='m125.413 126.441c-1.896 0-3.709-1.084-4.55-2.921-6.386-13.96-20.463-22.98-35.863-22.98s-29.477 9.021-35.863 22.98c-1.149 2.511-4.118 3.614-6.627 2.467-2.511-1.148-3.616-4.116-2.467-6.627 8.009-17.508 25.656-28.82 44.957-28.82s36.948 11.312 44.957 28.82c1.149 2.511.044 5.479-2.467 6.627-.674.309-1.381.454-2.077.454z'
      />
    </svg>
  )
}
export default BadSmileyIcon
